import type { AreaMapObject, Point2D } from "../types";

export interface AreaRaw {
    min: Point2D;
    max: Point2D;
    z: number;
    [key: string]: unknown;
}

export type RawAreasByGrid = Record<string, Record<string, AreaRaw>>;

export function parseAreas(
    areas: RawAreasByGrid | null | undefined,
): AreaMapObject[] {
    if (!areas) return [];

    return Object.entries(areas).flatMap(([colName, rows]) =>
        Object.entries(rows).map(([rowName, raw]) => ({
            id: `area:${colName}:${rowName}`,
            type: "area",
            label: `${colName}\n${rowName}`,
            x: raw.min.x,
            y: raw.min.y,
            z: raw.z,
            width: raw.max.x - raw.min.x,
            height: raw.max.y - raw.min.y,
            interactive: true,
        })),
    );
}
